// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  color: var(--ion-color-subtitle);
  text-align: left !important;
}

.container {
  max-height: 200px;
  overflow: auto;
}

.default-img {
  border-radius: 4px;
  padding: 20px;
  object-fit: contain;
  height: 200px !important;
}

.article-info {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.article-info ion-img {
  height: 150px;
  margin-bottom: 16px;
}
.article-info .name {
  font-family: AppFontBold;
  font-size: 26px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  padding-bottom: 16px;
}
.article-info .desc {
  font-family: AppFont;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: rgba(47, 51, 58, 0.6980392157);
  margin-bottom: 16px;
}
.article-info .desc ::ng-deep p {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  text-align: inherit;
  color: inherit;
}
.article-info .info ::ng-deep p {
  font-family: AppFont;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  margin-bottom: 30px;
}

.nutrition-title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 18.27px;
  text-align: start !important;
  color: var(--color-black);
  margin-bottom: 20px;
}

.nutrition-subtitle {
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  padding-top: 16px;
  margin-bottom: 12px;
  border-top: 1px solid rgba(112, 113, 115, 0.2);
}

.nutrition-name,
.nutrition-value {
  font-family: AppFont;
  font-size: 14px;
  font-weight: 500;
  line-height: 18.27px;
  text-align: left;
  color: var(--color-black);
}

.nutrition-value {
  text-align: end !important;
  text-transform: lowercase;
}

p {
  line-height: 22px;
}

h1 {
  margin: 0;
  padding: 0 4px;
}

ul {
  padding: 0px;
  padding-left: 26px;
  -webkit-text-decoration: dotted;
          text-decoration: dotted;
  list-style-type: revert;
  margin: 0px 0px 10px 0px;
}

li {
  text-decoration: none;
  text-align: left;
  color: var(--color-black);
  font-size: 14px;
  margin-bottom: 12px;
}
li:last-child {
  margin-bottom: 0;
}

ion-icon {
  width: 48px;
  height: 48px;
}

h3 {
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  letter-spacing: 0px;
  color: var(--color-black);
}

.button-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 12px;
  width: 100%;
  box-shadow: 3px 0px 45px 0px rgba(0, 0, 0, 0.0705882353);
  background: var(--ion-color-secondary);
}

.footer-info {
  font-family: AppFont;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  color: #072633;
  padding-bottom: 12px;
  border-bottom: 1px solid #dce8f5;
  margin-bottom: 12px;
}

ion-button {
  width: 100%;
  min-height: 54px;
  --background: var(--ion-color-primary);
  --color: var(--ion-color-secondary);
  --border-color: var(--ion-color-primary);
  --border-style: solid;
  --border-width: 1px;
  --border-radius: 2px;
}
ion-button span {
  font-family: AppFont;
  font-size: 18px;
}

.inner-text {
  text-align: left;
  color: var(--color-black);
  font-size: 14px;
  margin: 5px 0 6px;
}

.line {
  width: 100%;
  height: 3px;
  margin: 10px 0px;
  fill: var(--ion-color-primary);
}

.cross {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.button-text {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  color: var(--ion-color-secondary);
}

.nutrition-value {
  text-align: right !important;
}

.nutrition ion-row {
  padding: 0;
  margin-left: -3px;
}
.nutrition ion-row:first-of-type {
  margin-top: 10px;
}
.nutrition ion-col {
  padding: 5px;
}

.overflow-auto {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.content-block {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 52px 18px 18px;
  background-color: var(--ion-color-secondary);
  flex-grow: 1;
}

.cross {
  --icon-color: var(--color-black);
  height: 19px;
  width: 19px;
  margin-left: auto;
  position: absolute;
  right: 20px;
  top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/short-info-modal/short-info-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,gCAAA;EACA,2BAAA;AADD;;AAIA;EACC,iBAAA;EACA,cAAA;AADD;;AAKA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EAEA,wBAAA;AAHD;;AAMA;EACC,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAHD;AAIC;EACC,aAAA;EACA,mBAAA;AAFF;AAIC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,oBAAA;AAFF;AAIC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;AAFF;AAGE;EACC,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AADH;AAMG;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAJJ;;AAUA;EACC,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;AAPD;;AAUA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,mBAAA;EACA,8CAAA;AARD;;AAWA;;EAEC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;AARD;;AAWA;EACC,0BAAA;EACA,yBAAA;AARD;;AAcA;EACC,iBAAA;AAXD;;AAcA;EACC,SAAA;EACA,cAAA;AAXD;;AAaA;EACC,YAAA;EACA,kBAAA;EACA,+BAAA;UAAA,uBAAA;EACA,uBAAA;EACA,wBAAA;AAVD;;AAYA;EACC,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AATD;AAWC;EACC,gBAAA;AATF;;AAYA;EACC,WAAA;EACA,YAAA;AATD;;AAqBA;EACC,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;AAlBD;;AAoBA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,wDAAA;EACG,sCAAA;AAjBJ;;AAmBA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AAhBD;;AAkBA;EACC,WAAA;EACA,gBAAA;EACA,sCAAA;EACA,mCAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;AAfD;AAgBC;EACC,oBAAA;EACA,eAAA;AAdF;;AAiBA;EACC,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AAdD;;AAgBA;EACC,WAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;AAbD;;AAeA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAZD;;AAcA;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;AAXD;;AAaA;EACC,4BAAA;AAVD;;AAcC;EACC,UAAA;EACA,iBAAA;AAXF;AAaE;EACC,gBAAA;AAXH;AAcC;EACC,YAAA;AAZF;;AAeA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAZD;;AAcA;EACC,aAAA;EACA,sBAAA;EAEA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,4CAAA;EACA,YAAA;AAZD;;AAeA;EACC,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAZD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n* {\n\tcolor: var(--ion-color-subtitle);\n\ttext-align: left !important;\n}\n\n.container {\n\tmax-height: 200px;\n\toverflow: auto;\n\n\t// padding-bottom: 80px;\n}\n.default-img {\n\tborder-radius: 4px;\n\tpadding: 20px;\n\tobject-fit: contain;\n\t// background-color: var(--ion-color-primary);\n\theight: 200px !important;\n}\n\n.article-info {\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\talign-items: center;\n\tion-img {\n\t\theight: 150px;\n\t\tmargin-bottom: 16px;\n\t}\n\t.name {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 26px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-transform: uppercase;\n\t\tpadding-bottom: 16px;\n\t}\n\t.desc {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 21px;\n\t\ttext-align: center;\n\t\tcolor: #2f333ab2;\n\t\tmargin-bottom: 16px;\n\t\t::ng-deep p {\n\t\t\tfont-family: inherit;\n\t\t\tfont-size: inherit;\n\t\t\tline-height: inherit;\n\t\t\ttext-align: inherit;\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\t.info {\n\t\t::ng-deep {\n\t\t\tp {\n\t\t\t\tfont-family: AppFont;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tline-height: 18px;\n\t\t\t\ttext-align: center;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.nutrition-title {\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 18.27px;\n\ttext-align: start !important;\n\tcolor: var(--color-black);\n\tmargin-bottom: 20px;\n}\n\n.nutrition-subtitle {\n\tfont-family: AppFontBold;\n\tfont-size: 18px;\n\tline-height: 100%;\n\tletter-spacing: -0.01em;\n\ttext-transform: uppercase;\n\n\tpadding-top: 16px;\n\tmargin-bottom: 12px;\n\tborder-top: 1px solid #70717333;\n}\n\n.nutrition-name,\n.nutrition-value {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tline-height: 18.27px;\n\ttext-align: left;\n\tcolor: var(--color-black);\n}\n\n.nutrition-value {\n\ttext-align: end !important;\n\ttext-transform: lowercase;\n}\n\n.compaunds {\n}\n\np {\n\tline-height: 22px;\n}\n\nh1 {\n\tmargin: 0;\n\tpadding: 0 4px;\n}\nul {\n\tpadding: 0px;\n\tpadding-left: 26px;\n\ttext-decoration: dotted;\n\tlist-style-type: revert;\n\tmargin: 0px 0px 10px 0px;\n}\nli {\n\ttext-decoration: none;\n\ttext-align: left;\n\tcolor: var(--color-black);\n\tfont-size: 14px;\n\tmargin-bottom: 12px;\n\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\nion-icon {\n\twidth: 48px;\n\theight: 48px;\n}\n\n// ion-row {\n//   padding: 8px;\n\n//   text-align: center;\n\n//   ion-col {\n//     padding: 12px;\n//   }\n// }\nh3 {\n\tfont-size: 16px;\n\tfont-family: AppFontBold, sans-serif;\n\tletter-spacing: 0px;\n\tcolor: var(--color-black);\n}\n.button-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 16px 12px;\n\twidth: 100%;\n\tbox-shadow: 3px 0px 45px 0px #00000012;\n    background: var(--ion-color-secondary);\n}\n.footer-info {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tline-height: 150%;\n\tletter-spacing: 0.02em;\n\ttext-transform: capitalize;\n\tcolor: #072633;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid #dce8f5;\n\tmargin-bottom: 12px;\n}\nion-button {\n\twidth: 100%;\n\tmin-height: 54px;\n\t--background: var(--ion-color-primary);\n\t--color: var(--ion-color-secondary);\n\t--border-color: var(--ion-color-primary);\n\t--border-style: solid;\n\t--border-width: 1px;\n\t--border-radius: 2px;\n\tspan {\n\t\tfont-family: AppFont;\n\t\tfont-size: 18px;\n\t}\n}\n.inner-text {\n\ttext-align: left;\n\tcolor: var(--color-black);\n\tfont-size: 14px;\n\tmargin: 5px 0 6px;\n}\n.line {\n\twidth: 100%;\n\theight: 3px;\n\tmargin: 10px 0px;\n\tfill: var(--ion-color-primary);\n}\n.cross {\n\twidth: 24px;\n\theight: 24px;\n\tmargin-right: 5px;\n\tmargin-bottom: 5px;\n}\n.button-text {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 18px;\n\tcolor: var(--ion-color-secondary);\n}\n.nutrition-value {\n\ttext-align: right !important;\n}\n\n.nutrition {\n\tion-row {\n\t\tpadding: 0;\n\t\tmargin-left: -3px;\n\n\t\t&:first-of-type {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n\tion-col {\n\t\tpadding: 5px;\n\t}\n}\n.overflow-auto {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n.content-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\t// height: calc(100% - 75px);\n\theight: 100%;\n\toverflow-y: auto;\n\tpadding: 52px 18px 18px;\n\tbackground-color: var(--ion-color-secondary);;\n\tflex-grow: 1;\n}\n\n.cross {\n\t--icon-color: var(--color-black);\n\theight: 19px;\n\twidth: 19px;\n\tmargin-left: auto;\n\tposition: absolute;\n\tright: 20px;\n\ttop: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
